import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Alert,
  Button,
  ButtonGroup,
  Spinner
} from "reactstrap";
import request from "common/request";

const propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
  requestUrl: PropTypes.string.isRequired,
  campaignName: PropTypes.string.isRequired,
  currentEmail: PropTypes.string.isRequired
};

const GenerateAddressModal = ({
  isOpen,
  onClose,
  onSuccess,
  requestUrl,
  campaignName,
  currentEmail
}) => {
  const [isProcessing, setIsProcessing] = useState(false);
  const [newEmail, setNewEmail] = useState(null);
  const [error, setError] = useState(null);

  const handleGenerate = async () => {
    setIsProcessing(true);
    setError(null);
    try {
      const response = await request.patch(requestUrl);
      setNewEmail(response.data.email);
      setIsProcessing(false);
    } catch (e) {
      setIsProcessing(false);
      setError(e?.response?.data?.error || "An error occurred. Please try again.");
    }
  };

  const handleClose = () => {
    if (newEmail) {
      onSuccess();
    } else {
      onClose();
    }
  };

  const isConfirming = !isProcessing && !newEmail && !error;

  return (
    <Modal
      isOpen={isOpen}
      toggle={isProcessing ? undefined : handleClose}
      fade={false}
      size="lg"
      className="account-app modal-dialog-centered"
    >
      <ModalHeader toggle={isProcessing ? undefined : handleClose} className="p-3">
        Generate Quick Adder™ campaign address
      </ModalHeader>
      <ModalBody className="px-4 pt-0 pb-3 text-center">
        <h5 className="font-weight-bold mb-3">
          Current Quick Adder™ address for {campaignName}:
          <div className="text-break mt-1">{newEmail || currentEmail}</div>
        </h5>
        {isProcessing && (
          <>
            <Spinner color="primary" className="mb-3" />
            <p>Generating new address...</p>
          </>
        )}
        {error && (
          <Alert color="danger" toggle={() => setError(null)}>
            {error}
          </Alert>
        )}
        {newEmail && (
          <Alert color="success">
            <span className="font-weight-bold">Success!</span> New Quick Adder™ address for{" "}
            {campaignName} is: {newEmail}
          </Alert>
        )}
        {isConfirming && (
          <Alert color="warning">
            Warning: This is a permanent action. Updating the Quick Adder™ address will disable the
            old address.
          </Alert>
        )}
      </ModalBody>
      {!isProcessing && (
        <ModalFooter>
          {isConfirming ? (
            <ButtonGroup>
              <Button color="primary" className="btn-sharp mx-1" onClick={handleGenerate}>
                Generate new address
              </Button>
              <Button color="secondary" className="btn-sharp mx-1" onClick={handleClose}>
                Cancel
              </Button>
            </ButtonGroup>
          ) : (
            <Button color="primary" className="btn-sharp" onClick={handleClose}>
              Close
            </Button>
          )}
        </ModalFooter>
      )}
    </Modal>
  );
};

GenerateAddressModal.propTypes = propTypes;

export default GenerateAddressModal;
